// Creates a stable string key for a given context object,
// ensuring consistent ordering of keys (important for cache hits)
export const getContextKey = (context: Record<string, unknown>) =>
  JSON.stringify(Object.fromEntries(Object.entries(context).sort()));
